try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { ErrorMessage } from '@design-system/error-message';
import { FieldHead } from '@design-system/field-head';
import { forwardRef, useState } from 'react';

const RadioButton = ({ id, label, value, name, onChange, onBlur, isDisabled, isError, variant, checked, }) => (jsxs("div", Object.assign({ className: classNames('cds-radio-button__input-container', `cds-radio-button__input-container__${variant}`, { [`cds-radio-button__input-container__${variant}--error`]: isError }, {
        [`cds-radio-button__input-container__${variant}--disabled`]: isDisabled,
    }) }, { children: [jsx("span", { children: jsx("input", { className: classNames('cds-radio-button__input', `cds-radio-button__input--${variant}`, {
                    'cds-radio-button__input--error': isError,
                    'cds-radio-button__input--disabled': isDisabled,
                }), type: "radio", value: value, onChange: onChange, checked: checked, onBlur: onBlur, disabled: isDisabled, name: name, id: id }) }), jsx("label", Object.assign({ className: classNames('cds-radio-button__label', `cds-radio-button__label--${variant}`, {
                'cds-radio-button__label--error': isError,
                'cds-radio-button__label--disabled': isDisabled,
            }), htmlFor: id }, { children: label }))] })));

const RadioList = forwardRef(({ onChange, onBlur, variant = 'default', options, className, errorMessage, description, tooltipLabel, tooltipText, defaultValue, isDisabled, id, label: fieldHeadLabel, }, ref) => {
    const [selectedValue, setSelectedValue] = useState({
        value: defaultValue || '',
        name: '',
    });
    const handleOnChange = ({ target: { value, name }, }) => {
        const newValue = { value, name };
        setSelectedValue(newValue);
        if (onChange)
            onChange(newValue);
    };
    return (jsxs("div", Object.assign({ className: classNames('cds-radio-list', className), "data-testid": "cds-radio-list", ref: ref }, { children: [fieldHeadLabel ? (jsx(FieldHead, { id: id, label: fieldHeadLabel, description: description, tooltipLabel: tooltipLabel, tooltipText: tooltipText })) : null, options.map(({ value, label, name, isError }) => (jsx(RadioButton, { name: name, label: label, value: value, onBlur: onBlur, variant: variant, isDisabled: isDisabled, onChange: handleOnChange, isError: isError, checked: selectedValue.value === value, id: `${value}${label}` }, value))), jsx(ErrorMessage, { message: errorMessage })] })));
});

export { RadioButton, RadioList };
